import { useMemo } from 'react';
import { Flex } from 'src/components/UI/Flex';
import { useIsMobile } from 'src/helpers/useIsMobile';
import { openAppStore, openPlayStore, verifyOSSystem, OS_TYPES } from 'src/helpers/window';
import AppleIcon from 'src/components/Icons/AppleIcon';
import GooglePlayIcon from 'src/components/Icons/GooglePlayIcon';
import { ReactComponent as AppStoreQRCode } from 'src/assets/images/app-store-qr-code.svg';
import { ReactComponent as PlayStoreQRCode } from 'src/assets/images/play-store-qr-code.svg';
import { StoreCard } from 'src/containers/ConfirmEmail/StoreCard';
import {
  trackOnboardingSuccessAppStoreClick,
  trackOnboardingSuccessGooglePlayClick,
} from 'src/services/tracking/events/onboarding.events';

export function StoreDownloadSection() {
  const isMobile = useIsMobile();
  const osType = useMemo(() => verifyOSSystem(), []);

  const showAppStore = !isMobile || osType === OS_TYPES.IOS || osType === OS_TYPES.UNKNOWN;
  const showPlayStore = !isMobile || osType === OS_TYPES.ANDROID || osType === OS_TYPES.UNKNOWN;

  const handleAppStoreClick = () => {
    trackOnboardingSuccessAppStoreClick();
    openAppStore();
  };

  const handlePlayStoreClick = () => {
    trackOnboardingSuccessGooglePlayClick();
    openPlayStore();
  };

  return (
    <Flex justify="flex-start" w="100%">
      <Flex gap="16px" direction={{ base: 'column', sm: 'row' }} w={{ base: '100%', lg: 'auto' }}>
        {showAppStore && (
          <StoreCard
            storeName="Disponível na"
            storeLabel="App Store"
            icon={<AppleIcon width={20} />}
            qrCode={<AppStoreQRCode width={90} height={90} />}
            onClick={handleAppStoreClick}
            isMobile={isMobile}
          />
        )}
        {showPlayStore && (
          <StoreCard
            storeName="Disponível na"
            storeLabel="Google Play"
            icon={<GooglePlayIcon width={20} />}
            qrCode={<PlayStoreQRCode width={90} height={90} />}
            onClick={handlePlayStoreClick}
            isMobile={isMobile}
          />
        )}
      </Flex>
    </Flex>
  );
}
